<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <h1>PERKI Mobile CMS</h1>
          <p>Admin Login</p>
        </div>

        <a-form :model="form" layout="vertical" @finish="handleSubmit">
          <a-form-item
            label="Email"
            name="email"
            :rules="[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' },
            ]"
          >
            <a-input v-model:value="form.email" size="large" placeholder="Enter email" />
          </a-form-item>

          <a-form-item
            label="Password"
            name="password"
            :rules="[{ required: true, message: 'Please input your password!' }]"
          >
            <a-input-password
              v-model:value="form.password"
              size="large"
              placeholder="Enter password"
            />
          </a-form-item>

          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              size="large"
              block
              :loading="loading"
              class="login-btn"
            >
              Sign In
            </a-button>
          </a-form-item>
        </a-form>

        <div v-if="errorMsg" class="error-message">
          <a-alert type="error" :message="errorMsg" show-icon />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { mobileCmsAuthAPI } from '@/services/axios/perki/mobileCms'
import { notification } from 'ant-design-vue'

export default {
  name: 'MobileCmsLogin',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const loading = ref(false)
    const errorMsg = ref('')
    const form = reactive({
      email: '',
      password: '',
    })

    const handleSubmit = async () => {
      loading.value = true
      errorMsg.value = ''

      try {
        const response = await mobileCmsAuthAPI.login(form)
        const result = response.data.result

        // Store token and user in localStorage
        localStorage.setItem('mobile_cms_token', result.token)
        localStorage.setItem('mobile_cms_user', JSON.stringify(result.user))
        localStorage.setItem('mobile_cms_role', result.user.role)

        // Redirect: honour ?redirect query param, otherwise go to dashboard
        const redirect = route.query.redirect
        router.push(redirect || '/mobile-cms')
      } catch (error) {
        if (error.response && error.response.data) {
          errorMsg.value = error.response.data.result || 'Login gagal'
          notification.error({
            message: 'Login Failed',
            description: errorMsg.value,
          })
        } else {
          errorMsg.value = 'Terjadi kesalahan. Silakan coba lagi.'
          notification.error({
            message: 'Login Failed',
            description: errorMsg.value,
          })
        }
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      loading,
      errorMsg,
      handleSubmit,
    }
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 450px;
  padding: 2rem;
}

.login-container {
  width: 100%;
  max-width: 450px;
}

.login-card {
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.login-header p {
  color: #666;
  font-size: 1rem;
}

.login-btn {
  background-color: #e10f28 !important;
  border-color: #e10f28 !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border-radius: 26px;
}

.login-btn:hover {
  background-color: #d62828 !important;
  border-color: #d62828 !important;
}

.error-message {
  margin-top: 1rem;
}

@media (max-width: 576px) {
  .login-card {
    padding: 2rem 1.5rem;
  }
}
</style>
